import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'María Fernanda López',
  age: 34,
  role: 'Docente de Secundaria',
  city: 'Córdoba',
  text: 'Siempre me costaba encontrar actividades para trabajar ESI con adolescentes. Este material me resolvió las clases porque cada página ya está lista para imprimir.'
}, {
  name: 'Carolina Ruiz',
  age: 41,
  role: 'Docente de Secundaria',
  city: 'Rosario',
  text: 'Lo que más valoro es que las propuestas están pensadas realmente para secundaria. Los estudiantes participan mucho más porque los temas son actuales.'
}, {
  name: 'Luciana Gómez',
  age: 29,
  role: 'Docente de Secundaria',
  city: 'Buenos Aires',
  text: 'Los temas más difíciles eran los que más me preocupaban. Con este material pude trabajar bullying, redes sociales y salud mental con mucha más tranquilidad.'
}];
export function TestimonialsSection() {
  return <section className="py-6 px-4 bg-gray-50" data-id="element-350" data-mp="32eop0wlk8tvu">
      <div className="max-w-6xl mx-auto" data-id="element-351" data-mp="2v0sv1a21463w">
        <h2 className="text-[20px] font-black mb-5 text-center text-[#5B3FA0]" data-id="element-352" data-mp="2uzrkr7su7nn8">
          Lo que dicen otras docentes
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-353" data-mp="34re09gc7k8vs">
          {testimonials.map((t, index) => <div key={index} className="bg-white p-4 rounded-2xl shadow-md border border-gray-100 flex flex-col" data-id="element-354" data-mp="2zs16ebmx61jp" data-mpi={index}>
              <div className="flex mb-2" data-id="element-355" data-mp="2c4jl8yy5u1pp">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-356" data-mp="275q7d5eyo8p0" data-mpi={i} />)}
              </div>
              <p className="text-gray-700 italic mb-3 flex-grow" data-id="element-357" data-mp="2h0i303ozglh5">"{t.text}"</p>
              <div className="border-t pt-3 mt-auto" data-id="element-358" data-mp="19cctyu9cpki">
                <p className="font-bold text-gray-900" data-id="element-359" data-mp="3sgymc83nrm9a">
                  {t.name}, {t.age} años
                </p>
                <p className="text-sm text-gray-500" data-id="element-360" data-mp="3fad2n09r1rm">{t.role}</p>
                <p className="text-sm text-gray-500" data-id="element-361" data-mp="3h4y01bjitvp">{t.city}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}